import { combineReducers } from "@reduxjs/toolkit";
import trelloReducer from "./reducers/trello/slice";
import userReducer from "./reducers/user/slice";

const rootReducer = combineReducers({
  trello: trelloReducer,
  user: userReducer,
});

export default rootReducer;
